import React, { type FC } from 'react';
import { useTemplatesData } from '../../../hooks/useTemplatesData';
import { TemplatesGrid } from '../../CommonComponents/TemplatesGrid/TemplatesGrid';
import css from '../TemplatePage.scss';
import { Divider, Heading } from '@wix/design-system';
import { usePageNavigate } from '../../../hooks/usePageNavigate';
import { useTranslation } from '@wix/wix-i18n-config';
import type { AppTemplate } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';

export const RelatedTemplates: FC = () => {
  const { t } = useTranslation();
  const {
    currentTemplate: { relatedTemplates: relatedIds },
  } = useTemplatesData();

  const { templates } = useTemplatesData();
  const { navigateToTemplate, getExternalTemplateUrl } = usePageNavigate();
  const { reportRelatedTemplateClick } = useTemplatesPageBi();
  const relatedTemplates = templates.filter((template) =>
    relatedIds.includes(template.id),
  );
  if (!relatedTemplates?.length) {
    return null;
  }

  const onItemClick = (item: AppTemplate) => {
    reportRelatedTemplateClick(item.id, getExternalTemplateUrl(item));
    navigateToTemplate(item);
  };

  return (
    <>
      <div className={css.divider}>
        <Divider skin="light" />
      </div>
      <div className={css.relatedTemplatesWrapper}>
        <Heading size="large">
          {t('app.template-page.related-templates.title')}
        </Heading>
        <TemplatesGrid
          showMoreThanTwoInRow={false}
          templates={relatedTemplates}
          onTemplateClick={onItemClick}
        />
      </div>
    </>
  );
};
